import { LinkTargetType } from "../../services/playground";
export function runInBrowser() {
    return !!window;
}
export const isInWindowView = (ele, fixedTop = 0) => {
    if (!runInBrowser()) {
        return false;
    }
    const { top, bottom } = ele.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    if (bottom <= fixedTop) {
        return false;
    }
    if (top >= windowHeight - fixedTop) {
        return false;
    }
    return true;
};
export const transformAParam = ({ isInApp = true, aTarget = LinkTargetType.Blank, link = "", onClick, }) => {
    if (!link) {
        return {};
    }
    if (link.startsWith("#")) {
        return {
            href: link,
            target: LinkTargetType.Self,
        };
    }
    if (isInApp || aTarget === LinkTargetType.Self) {
        return {
            href: link,
            target: aTarget,
        };
    }
    return {
        onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick && onClick();
            window.open(link);
        },
        "data-href": link
    };
};
